const dayStartChoicesBg = [
  {
    label: "Със спокойна сутрешна разходка край морето.",
    value: 'With a peaceful morning walk by the sea.{"Blue":"3","Violet":"2"}',
  },
  {
    label: "С енергична тренировка.",
    value: 'With an active workout.{"Red":"3","Yellow":"2"}',
  },
  {
    label: "С топла чаша кафе в уютен ъгъл.",
    value:
      'With a warm cup of coffee in a cozy corner.{"Brown":"3","Green":"2"}',
  },
  {
    label: "С тих момент на медитация в минималистично пространство.",
    value:
      'With a quiet moment of meditation in a minimalist space.{"Gray":"3","Black":"2"}',
  },
];

export default dayStartChoicesBg;
